import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { AlertInactivityModalComponent } from '../components/alert-inactivity-modal/alert-inactivity-modal.component';
import { AuthService } from './auth.service';
import { StayConnected, UtilService } from './util.service';
import { AutomaticLoginService } from './API/user/automatic-login.service';
import { DigitalSignatureUtilService } from './digital-signature-util.service';
import { HealthUnitService } from './API/user/health-unit.service';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class InactivityTimeoutService {

  constructor(private idle: Idle, 
    private router: Router,
    public dialog: MatDialog,
    private authService: AuthService,
    private utilService: UtilService,
    private automaticLoginService: AutomaticLoginService,
    private digitalSignatureUtil: DigitalSignatureUtilService,
    private healthUnitService: HealthUnitService, 
  ) {
    // this.getConfi();
  }

  idleState = 'Not started.';
  timedOut = false;
  timeoutWarningShown = false;

  private idleStartSub?: Subscription;
  private idleEndSub?: Subscription;
  private timeoutSub?: Subscription;
  private timeoutWarningSub?: Subscription;
  private alreadySetupIdle = false;
  
  private totalIdleTime = 5 * 60; // fallback: 5 minutos
  private warningTime = 60; // sempre 1 min antes do total

  getConfi() {
    this.healthUnitService.getHealthUnitInactivityTimeout().subscribe({
      next: (response) => {
        
        if (response.isError) {
          console.log(response.errorDescription);
          return;
        }
        
        if(response.inactivityLogoutTimeout && response.inactivityLogoutTimeout.value) {
          this.totalIdleTime = (response.inactivityLogoutTimeout.value - 1) * 60;
          this.setupIdle();
          this.startWatching();
        }
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  private setupIdle() {
    this.idle.setIdle(this.totalIdleTime);
    
    this.idle.setTimeout(this.warningTime);
    
    if (this.alreadySetupIdle) {
      return;
    }

    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idleEndSub = this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.timeoutWarningShown = false;
    });

    this.timeoutSub = this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.timeoutWarningShown = false;
      // alert(`Sua sessão foi encerrada por inatividade.`);
      // this.logout();
    });

    this.idleStartSub = this.idle.onIdleStart.subscribe(() => {
      this.idleState = 'You have gone idle!';
    });

    this.timeoutWarningSub = this.idle.onTimeoutWarning.subscribe((countdown: number) => {
      this.idleState = 'You will time out in ' + countdown + ' seconds!';
      if (!this.timeoutWarningShown && countdown <= this.warningTime) {
        this.timeoutWarningShown = true;
        this.idle.stop();
        const dialogRef = this.dialog.open(AlertInactivityModalComponent, {
          disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
          this.timeoutWarningShown = false;
          if (result && result.continueSession) {
            this.resetTimer();
          } else {
            this.logout();
          }
          
        });
      }
    });

    this.alreadySetupIdle = true;
  }

  startWatching() {
    this.idleState = 'Started'
    this.idle.watch();
    this.timedOut = false;
  }

  stopWatching() {
    this.idleState = 'Stoped';
    this.idleStartSub?.unsubscribe();
    this.idleEndSub?.unsubscribe();
    this.timeoutSub?.unsubscribe();
    this.timeoutWarningSub?.unsubscribe();
    this.idle.stop();
    this.idle.clearInterrupts();
    this.alreadySetupIdle = false;
  }

  resetTimer() {
    this.startWatching();
  }

  isRunning() {
    return this.idle.isRunning();
  }

  logout() {
    let stayConnected: StayConnected = this.utilService.getGuidStayConnected();
    this.digitalSignatureUtil.clear();

    if (stayConnected) {
      this.deleteAutomaticLogin(stayConnected);
      this.utilService.cleanGuidStayConnected();
    }

    alert(`Sua sessão foi encerrada por inatividade.`);
    this.authService.logout();
  }

  deleteAutomaticLogin(stayConnected: StayConnected) {
    this.automaticLoginService.deleteAutomaticLoginByGuid(stayConnected.guid).subscribe({
      next: response => {
        if (response.isError) {
          return;
        }

      },
      error: error => {
        console.log(error);
      }
    });
  }
}
